<template>
  <div v-if="data !== null">
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="clearfix"></div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm"></div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
            <div class="header-wrapper">
              <h2 class="text-primary-fh text-left">Provresultat för minderårigt barn <br />
              <span v-if="currentChild">{{ currentChild.firstName + ' ' + currentChild.lastName }}</span>
              </h2>
              <div class="clearfix"></div>
              <br /><br />
            </div>
            <div class="card dashboard-card">
              <h5 class="text-primary-fh left-header">Provsvar</h5>
              <p v-html="data.dashboard.labresultsCardTextMinor"></p>
              <small class="text-right">{{ getTestDate(bloodTest) }}</small>
              <ul class="ul-list list-group list-group-flush bg-transparent">
                <li class="list-group-item bg-transparent">
                  Totalkolesterol <span class="lab-results-values" v-if="bloodTest">
                    {{ bloodTest.totalKolesterol }} {{ bloodTest.totalKolesterolUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodTest">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  Triglycerider <span class="lab-results-values" v-if="bloodTest">
                    {{ bloodTest.triglycerider }} {{ bloodTest.triglyceriderUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodTest">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  HDL kolesterol <span class="lab-results-values" v-if="bloodTest">
                    {{ bloodTest.hdl }} {{ bloodTest.hdlUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodTest">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  LDL kolesterol <span class="lab-results-values" v-if="bloodTest">
                    {{ bloodTest.ldl }} {{ bloodTest.ldlUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodTest">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  Lipoprotein (a) <span class="lab-results-values" v-if="bloodTest">
                    {{ bloodTest.lipoProteinA }} {{ bloodTest.lipoProteinAUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodTest">-</span>
                </li>
              </ul>
              <ul class="ul-list list-group list-group-flush bg-transparent">
                <div class="clearfix"></div>
                <p v-html="data.dashboard.referenceIntervalText"></p>
                <li class="list-group-item bg-transparent">
                  Totalkolesterol
                  <span class="lab-results-values" v-if="bloodTest">
                    {{ bloodTest.totalKolesterolReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodTest">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  Triglycerider
                  <span class="lab-results-values" v-if="bloodTest">
                    {{ bloodTest.triglyceriderReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodTest">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  HDL kolesterol
                  <span class="lab-results-values" v-if="bloodTest">
                    {{ bloodTest.hdlReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodTest">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  LDL kolesterol
                  <span class="lab-results-values" v-if="bloodTest">
                    {{ bloodTest.ldlReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodTest">-</span>
                </li>
              </ul>
            </div>
            <div class="clearfix"></div>
            <div class="card dashboard-card" v-if="geneticTestData && geneticTestData.mutation">
              <h5 class="text-primary-fh left-header">Resultat av ditt gentest</h5>
              <p v-if="geneticTestData.mutation" v-html="data.dashboard.genTestMutationPositiveText"></p>
              <p v-if="geneticTestData.mutation">{{geneticTestData.mutation}}</p>
              <p v-if="!geneticTestData.mutation" v-html="data.dashboard.genTestMutationNegativeText"></p>
              <a
                href="https://www.karolinska.se/for-vardgivare/karolinska-universitetslaboratoriet/klinisk-genetik/"
                target="_blank"
                class="text-primary-fh left-header samplepoints-link"
              >
                <img src="@/assets/img/external-link.svg?data" alt="Ikon för extern länk" class="img-fluid" />
                <span> Läs mer om genmutationer</span>
              </a>
            </div>
            <div class="clearfix"></div>
            <div class="card dashboard-card" v-if="fhDiagnosis">
              <p class="text-dark">
                <strong>Från vårdgivaren (beslut)</strong>:
                <br />
                {{ fhDiagnosis.patientText || 'Här kommer meddelande från din vårdgivare att visas' }}
              </p>
            </div>
            <div class="card dashboard-card" v-if="bloodTestAssessment">
              <p class="text-dark">
                <strong>Från vårdgivaren (provsvar)</strong>:
                <br />
                {{ bloodTestAssessment.patientText || 'Här kommer meddelande från din vårdgivare att visas' }}
              </p>
            </div>
            <div class="clearfix"></div>
            <button class="btn btn-outline-dark btn-lg btn-block" @click="$router.go(-1)">&#8592; Tillbaka</button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { request } from '../plugins/datocms'

export default {
  name: 'dashboardminor',
  components: {
    Top,
    Bottom,
    Pagination
  },
  props: ['id'],
  data () {
    return {
      data: null,
      bloodTest: null,
      bloodTestAssessment: null,
      geneticTestData: null,
      fhDiagnosis: null,
      currentChild: null
    }
  },
  methods: {
    getTestDate (bloodtest) {
      if (bloodtest !== null) {
        return new Date(bloodtest.testDate).toLocaleDateString()
      } else {
        return '-'
      }
    },
    async getChildrenUnder13BloodTestAssessment () {
      axios._get(config.childrenUnder13Uri + config.bloodtestassessmentUri + '?PersonId=' + parseInt(this.$props.id)).then(response => {
        this.bloodTest = response.data.bloodTest
        this.bloodTestAssessment = response.data.assessment
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get child under 13 bloodtestassessment: ' + error)
        }
      })
    },
    async getChildrenUnder13Mutation () {
      axios._get(config.childrenUnder13Uri + config.mutationUri + '?PersonId=' + parseInt(this.$props.id)).then(response => {
        this.geneticTestData = response.data.geneticTestData
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get child under 13 mutation: ' + error)
        }
      })
    },
    async getChildrenUnder13Diagnosis () {
      axios._get(config.childrenUnder13Uri + config.diagnosisUri + '?PersonId=' + parseInt(this.$props.id)).then(response => {
        this.fhDiagnosis = response.data.fhDiagnosis
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get child under 13 diagnosis: ' + error)
        }
      })
    },
    async getChildrenUnder13TestResults () {
      let loader = this.$loading.show()
      axios._get(config.childrenUnder13Uri + config.testresultsUri).then(response => {
        if (response) {
          const children = response.data.childrenWithTestResults
          if (children) {
            this.currentChild = children.find(c => c.personId === parseInt(this.$props.id))
          }
          loader.hide()
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get child under 13 diagnosis: ' + error)
          loader.hide()
        }
      })
    }
  },
  async beforeMount () {
    await this.getChildrenUnder13BloodTestAssessment()
    await this.getChildrenUnder13Mutation()
    await this.getChildrenUnder13Diagnosis()
    await this.getChildrenUnder13TestResults()
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          dashboard {
            welcomeHeader
            welcomeText
            remittanceHeader
            samplesdoneheader
            remittancedoneheader
            kinshipHeader
            welcomeremittanceheader
            welcomeremittancetext
            welcomegenresultsHeader
            welcomegenresultsPositiveText
            welcomegenresultsNegativeText
            labresultsCardTextMinor
            startscreeningandremittancebtn
            referenceIntervalText
            genTestSamplingHeader
            genTestSamplingText
            genTestMutationNegativeText
            genTestMutationPositiveText
            referralToRegionText
            referralToRegionSkaneText
            sampleEquipmentText
          }
          misc {
            facilitylist
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-top: 125px;
  margin-bottom: 50px;
  min-height: 65vh;
}
@media screen and (min-width: 800px) {
  .header-wrapper {
    display: flex;
  }
}
.create-remittance-btn {
  margin-bottom: 1vh;
}
.img-logo {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 10px;
  width: 10%;
}
.ul-list {
  border-top: 0;
  text-align: left;
  display: inline-grid;
}
.left-header {
  text-align: left;
}
.text-right {
  display: inline;
  position: absolute;
  top: 0;
  right: 0;
  margin: 1.5em;
}
.margin-left {
  margin-left: 30px;
}
.lab-results-values {
  float: right;
  font-weight: bold;
  font-size: 1.1em;
}
.samplepoints-link span {
  vertical-align: text-top;
}
.dashboard-card {
  padding: 15px 15px 15px 15px;
  background: #e5f1f5;
  margin-bottom: 25px;
  border: 2px solid #069ccc;
  border-radius: 15px;
}
.no-border {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardMinor.vue